export default {
  tourData: {
    fallback: {
      included: ['Excursion incluse', 'Accueil local', 'Expérience exclusive à Paraty'],
      notIncluded: ['Repas et boissons', "Transfert depuis l'hôtel"],
      bringItems: ['Crème solaire', 'Vêtements légers', 'Eau', 'Appareil photo'],
      meetingPoint: 'Paraty, RJ',
      startTime: 'À confirmer',
      maxGroupSize: 'Groupe',
      cancellation: "Consultez la politique d'annulation de l'excursion.",
      privacyPolicy: 'Politique de confidentialité disponible sur le site.',
      importantNotes: ["Confirmez l'horaire avec l'équipe avant l'excursion."],
      genericTag: 'Excursion en bateau',
    },
  },
};
